import { HStack, MenuItem, VStack } from '@chakra-ui/react';
import { Image, ImageMap } from '@common/components/Image';
import React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from '../components/TextBlock';

type NavbarSubmenuItemProps = {
  label: string;
  description: string;
  tag: string;
  href?: string;
  route?: string;
  image: keyof typeof ImageMap;
  borderBottom?: string;
};

export const NavbarSubmenuItem: React.FC<NavbarSubmenuItemProps> = ({
  description,
  tag,
  image,
  href,
  label,
  route,
  ...props
}) => {
  return (
    <MenuItem
      backgroundColor="transparent"
      borderBottom={props.borderBottom}
      as={Link}
      to={route ?? href ?? ''}
      _hover={{
        backgroundColor: 'gray.50',
      }}>
      <HStack padding="20px 5px" gap="5px" maxW={'300px'}>
        <Image image={image} boxSize={'45px'} />
        <VStack alignItems={'flex-start'}>
          <HStack alignItems={'center'}>
            <TextBlock as="span" fontSize="18px" lineHeight={'18px'} weight="bold">
              {label}
            </TextBlock>
            <TextBlock
              as="span"
              backgroundColor="black"
              color="white"
              weight="bold"
              fontSize={'8px'}
              padding="2px 4px"
              borderRadius={'4px'}>
              {tag}
            </TextBlock>
          </HStack>
          <TextBlock as="span" color="gray.300" fontSize="10px" lineHeight={'10px'} weight="bold">
            {description}
          </TextBlock>
        </VStack>
      </HStack>
    </MenuItem>
  );
};
